const fetcher_data =
{
    reads: [
        {
            name: "users",
            path: "/admin/users",
            method: "GET",
            formatter_function: (data) => {
                data = data.map((item) => {
                    let new_data = { ...item };

                    delete new_data["password"];
                    new_data["balance"] = new_data["balance"] / 100000000 + " USD";
                    return new_data;
                })

                console.log(data)
                return data;
            }

        },
        {
            name: "get_nowpayments",
            path: "/admin/get_nowpayments",
            method: "GET",
            formatter_function: (data) => {
                // data = data.map((item) => {
                //     let new_data = { ...item };

                //     delete new_data["password"];
                //     new_data["balance"] = new_data["balance"] / 100000000 + " USD";
                //     return new_data;
                // })

                data = data.payments.map((item) => {
                    let new_data = { ...item };

                    // delete new_data["password"];
                    new_data["is_finalized"] = new_data["is_finalized"] ? "✅" : "❌";

                    new_data["amount"] = new_data["amount"] + " " + "USD";
                    return new_data;
                });

                console.log(data)
                return data;
            }

        },
        {
            name: "positions",
            path: "/admin/positions",
            method: "GET",
            formatter_function: (data) => {
                data = data.map((item) => {
                    let new_data = { ...item };

                    // delete new_data["password"];
                    new_data["capital"] = new_data["capital"] / 100000000 + " USD";
                    return new_data;
                })

                console.log(data)
                return data;
            }

        },
        {
            name: "plans",
            path: "/plans",
            method: "GET",
            formatter_function: (data) => {
                data = data.map((item) => {
                    let new_data = { ...item };

                    // delete new_data["password"];
                    new_data["maximum_amount"] = new_data["maximum_amount"] / 100000000 + " USD";
                    new_data["minimum_amount"] = new_data["minimum_amount"] / 100000000 + " USD";
                    new_data["interest_rate"] = new_data["interest_rate"] + " %";
                    new_data["duration"] = new_data["duration"] + " " + new_data["duration_in"];
                    return new_data;
                })

                console.log(data)
                return data;
            }

        },

    ],
    writes: [
        {
            name: "create_plan",
            path: "/admin/create_plan",
            method: "POST",
            requiredData: [
                {
                    name: "id",
                    type: "string",
                },
                {
                    name: "name",
                    type: "string",
                },
                {
                    name: "minimum_amount",
                    type: "number",
                },
                {
                    name: "maximum_amount",
                    type: "number",
                },
                {
                    name: "interest_schedule",
                    type: "dropdown",
                    options: ["Hourly", "Daily", "Weekly", "Monthly", "Quarterly", "BiAnnually", "Yearly"]
                },
                {
                    name: "interest_rate",
                    type: "number",
                },
                {
                    name: "duration",
                    type: "number",
                },
                {
                    name: "duration_in",
                    type: "dropdown",
                    // Hours,
                    // Days,
                    // Weeks,
                    // Months,
                    // Years,
                    options: ["Hours", "Days", "Weeks", "Months", "Years"]
                },
                // {
                //     name: "open_days",
                //     type: "array",
                // },
                {
                    name: "refund_capital",
                    type: "boolean",
                },
                {
                    name: "auto_prevent_capital_withdrawal",
                    type: "boolean",
                },
                {
                    name: "status",
                    type: "dropdown",
                    options: ["Active", "Ended", "Suspended", "Hidden"]
                },

            ],
            formatter_function: (data) => {
                console.log(data)
            }
        },

        {
            name: "credit_user",
            path: "/admin/credit_user",
            method: "POST",
            requiredData: [
                {
                    name: "uuid",
                    type: "string",
                },
                {
                    name: "amount",
                    type: "number",
                }

            ],
            formatter_function: (data) => {
                console.log(data)
            }
        },

        {
            name: "debit_user",
            path: "/admin/debit_user",
            method: "POST",
            requiredData: [
                {
                    name: "uuid",
                    type: "string",
                },
                {
                    name: "amount",
                    type: "number",
                }

            ],
            formatter_function: (data) => {
                console.log(data)
            }
        },
        {
            name: "suspend_position",
            path: "/admin/suspend_position",
            method: "POST",
            requiredData: [
                {
                    name: "position_id",
                    type: "string",
                }

            ],
            formatter_function: (data) => {
                console.log(data)
            }
        },

        {
            name: "delete_plan",
            path: "/admin/delete_plan",
            method: "POST",
            requiredData: [
                {
                    name: "plan_id",
                    type: "string",
                }

            ],
            formatter_function: (data) => {
                console.log(data)
            }
        },

        {
            name: "site settings",
            path: "/admin/update_config",
            method: "POST",
            requiredData: [
                {
                    name: "domain",
                    type: "string",
                },
                {
                    name: "email",
                    type: "string",
                },
                {
                    name: "logo",
                    type: "string",
                },
                {
                    name: "logo_white",
                    type: "string",
                },
                {
                    name: "logo_blue",
                    type: "string",
                },
                {
                    name: "logo_black",
                    type: "string",
                },
                {
                    name: "logo_favicon",
                    type: "string",
                },
                {
                    name: "address",
                    type: "string",
                },
                {
                    name: "phone_number",
                    type: "string",
                },
                {
                    name: "site_name",
                    type: "string",
                },
                {
                    name: "tidio_id",
                    type: "string",
                },
                {
                    name: "tawk_to_id",
                    type: "string",
                },
                {
                    name: "livechat_key",
                    type: "string",
                },
            ],
            formatter_function: (data) => {
                console.log(data)
            }
        },

    ],

    async getData(route, formatter_function) {
        let random_id = Math.floor(Math.random() * 1000);
        let api = process.env.REACT_APP_BROKER_API;
        let path = api + route;


        console.log(`GET Broker request to ${path} with random id: ${random_id}`);
        try {
            let data = await fetch(path, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-tenant-id": `${localStorage.getItem("tenantId")}`,
                    "Authorization": `Bearer ${localStorage.getItem("token")}`

                },

            });

            let status = data.status;

            console.log(status)

            console.log(data)
            if (status == 401) {
                console.log("Unauthorized")
                return "Unauthorized"
            }
            if (status == 400) {
                console.log("Unauthorized")
                return "err"
            }
            data = await data.json();
            console.log(`GET request to ${route} with random id: ${random_id} returned: ${data}`);

            if (formatter_function) {
                data = formatter_function(data);
            }
            return data;


        } catch (e) {
            console.log(e)
            return "err"
        }


    },
    async postData(route, post_data) {
        let random_id = Math.floor(Math.random() * 1000);


        let api = process.env.REACT_APP_BROKER_API;
        console.log(`POST request to ${route} with data: ${post_data} with random id: ${random_id}`)

        let path = api + route;

        // trim all the strings in the post_data

        for (let key in post_data) {
            if (typeof post_data[key] == "string") {
                post_data[key] = post_data[key].trim();

            }
        }

        try {
            let data = await fetch(path, {
                method: "POST",
                body: JSON.stringify(post_data),
                headers: {
                    "Content-Type": "application/json",
                    "x-tenant-id": `${localStorage.getItem("tenantId")}`,
                    "Authorization": `Bearer ${localStorage.getItem("token")}`

                },
            });

            let status = data.status;
            if (status == 401) {
                console.log("Unauthorized")
                return "Unauthorized"
            }

            let json = await data.json();

            if (status == 400) {
                console.log("Unauthorized")
                return json.error || json.message || json;
            }

            console.log(`POST request to ${route} with data: ${data} with random id: ${random_id} returned: ${json}`);
            let returnData = {
                data: "Successful",
                status: 200
            }
            return returnData;

        } catch (e) {
            console.log(e)
            let returnData = {
                data: e,
                status: 500
            }
            return e.response;
        }

    }

}


export default fetcher_data;